module.exports = __webpack_public_path__ + "static/img/image001.c2c189f.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/news7/image001.png
// module id = N1bQ
// module chunks = 1